import { useTranslation } from '@web_opxp/features';
import * as React from 'react';

export interface INegativeFeedbackSurveyProps {
  onAnswer: (answer: number) => void;
}

const NegativeFeedbackSurvey: React.FC<INegativeFeedbackSurveyProps> = ({ onAnswer }) => {
  const { t } = useTranslation();

  const answerHandler = (answer: number) => (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    onAnswer(answer);
  };
  return (
    <div className="feedback-survey">
      <p className="survey-question">{t('Exercise.PostWorkout.Survey.NegativeFeedbackQuestion')}</p>
      <ul>
        <li className="survey-answer nn-button-medium" onClick={answerHandler(1)}>
          {t('Exercise.PostWorkout.Survey.NegativeOption1')}
        </li>
        <li className="survey-answer nn-button-medium" onClick={answerHandler(2)}>
          {t('Exercise.PostWorkout.Survey.NegativeOption2')}
        </li>
        <li className="survey-answer nn-button-medium" onClick={answerHandler(3)}>
          {t('Exercise.PostWorkout.Survey.NegativeOption3')}
        </li>
        <li className="survey-answer nn-button-medium" onClick={answerHandler(4)}>
          {t('Exercise.PostWorkout.Survey.NegativeOption4')}
        </li>
      </ul>
    </div>
  );
};
export default NegativeFeedbackSurvey;
